
import { CookieBannerMain } from "@/components/cookies/CookieBannerMain";

export function CookieBanner() {
  return <CookieBannerMain />;
}

export default CookieBanner;
